import React, { FC } from "react";
import styled from "styled-components";
import {
  ApolloClient,
  HttpLink,
  ApolloLink,
  InMemoryCache,
  concat,
} from "@apollo/client";
import { ApolloProvider } from "@apollo/react-hooks";

import Auth from "components/Auth";
import Layout from "components/Layout";
import Loader from "components/Loader";
import useAuth from "hooks/useAuth";

const cache = new InMemoryCache();
const uri = "https://blackbook-server.vercel.app/api/graphql";
// const uri = "http://localhost:8000/graphql";

const link = new HttpLink({
  uri,
});

function withAuth(BaseComponent: FC, showToken = false) {
  return function (props: any) {
    const { user, isLoading, error, requestLogin, token } = useAuth();

    const authMiddleware = new ApolloLink((operation, forward) =>
      forward(operation)
    );

    const client = new ApolloClient({
      cache,
      link: concat(authMiddleware, link),
    });

    if (isLoading) {
      return (
        <Layout>
          <Container>
            <Loader />
          </Container>
        </Layout>
      );
    }

    if (!user.loggedIn) {
      return <Auth onClick={requestLogin} error={error} />;
    }

    if (showToken) {
      return <p>{token}</p>;
    }

    return (
      <ApolloProvider client={client} {...props}>
        <BaseComponent {...props} />
      </ApolloProvider>
    );
  };
}

const Container = styled.div`
  display: flex;
  margin: 6rem;
  justify-content: center;
`;

export default withAuth;
